import type { ReactNode } from 'react'
import React from 'react'

import * as S from './LayoutMobile.styled'

type LayoutMobileProps = {
  content: ReactNode
  contentHeader: ReactNode
  contentFooter: ReactNode
  footer: ReactNode
  hideFooter: boolean
}

export const LayoutMobile = ({
  content,
  contentHeader,
  contentFooter,
  footer,
  hideFooter,
}: LayoutMobileProps) => {
  return (
    <S.Container>
      <S.MainContent>
        {content}
        <S.ContentHeader>{contentHeader}</S.ContentHeader>
        <S.ContentFooter>{contentFooter}</S.ContentFooter>
      </S.MainContent>
      {!hideFooter && <S.Footer>{footer}</S.Footer>}
    </S.Container>
  )
}
